import '../styles/NewTestRunMasthead.css';
import React from 'react';

function NewTestRunMasthead() {
  return (
    <section className="ntrm-root" aria-labelledby="ntrm-heading">
      <div className="ntrm-rail" data-content-rail="workspace">
        <div className="ntrm-band">
          <div className="ntrm-lead">
            <p className="ntrm-overline">New test run · configuration</p>
            <h1 id="ntrm-heading" className="ntrm-heading">
              <span>Configure</span>
              <span>a test run</span>
            </h1>
            <p className="ntrm-subline">
              Target, input format and run settings — validated before anything starts.
            </p>
          </div>

          <div className="ntrm-aside">
            <div className="ntrm-slip">
              <span className="ntrm-slip-label">Ethical lock</span>
              <span className="ntrm-sticker">Authorized target only</span>
            </div>
            <a className="ntrm-cancel" href="/dashboard">Cancel and return to Dashboard</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewTestRunMasthead;